import { Component, Element, h, Host, Prop } from '@stencil/core';
import { SustainabilityColorThemeType } from '../../../utils/sustainabilityColorTheme.types';

@Component({
    tag: 'sew-ws-animated-numbers',
    styleUrl: 'sew-ws-animated-numbers.scss',
    shadow: true,
})
export class SewWsAnimatedNumbers {
    @Element() host: HTMLSewWsAnimatedNumbersElement;
    @Prop({ reflect: true }) theme: SustainabilityColorThemeType = 'green';

    componentDidLoad() {
        this.host.querySelectorAll('sew-ws-animated-numbers-item').forEach((item, index, items) => {
            setTimeout(() => {
                item.classList.add('animate-in');

                if (index + 1 < items.length) {
                    setTimeout(() => item.classList.add('animate-out'), 2000);
                }
            }, index * 3000);
        });
    }
    render() {
        return (
            <Host>
                <slot></slot>
            </Host>
        );
    }
}
